import { Page } from '../types/core';

export const LOGIN_PAGE: Page = {
  id: 'login',
  name: 'Inicio de sesión',
  route: '/login',
};
export const FORGOTTEN_PASSWORD: Page = {
  id: 'forgottenPassword',
  name: 'Contraseña olvidada',
  route: '/forgotten-password',
};

export const DASHBOARD_PANELS_PAGE: Page = {
  id: 'dashboardPanels',
  name: 'Dashboard',
  icon: 'description',
  route: '/dashboard/:panelKey',
  navKey: 'dashboardPanels',
};

export const GPT_DETAIL_PAGE: Page = {
  id: 'gpt-detail',
  name: 'Evento safe GPT',
  route: '/safe-gpt/:eventId',
  navKey: 'gpt',
};

export const SESSION_404_PAGE: Page = {
  id: 'session-404',
  name: 'Error 404',
  route: '/*',
};

export const CORE_PAGE_IDS: string[] = [];

export const ALL_PAGES: Page[] = [LOGIN_PAGE, FORGOTTEN_PASSWORD, DASHBOARD_PANELS_PAGE, GPT_DETAIL_PAGE];

export const SMALL_LIST_ITEM_HEIGHT = 50;
export const DEFAULT_LIST_ITEM_HEIGHT = 65;
export const LARGE_LIST_ITEM_HEIGHT = 80;
export const EXTRA_LARGE_LIST_ITEM_HEIGHT = 100;

export const SIDENAV_WIDTH = 76;
export const EXPANDED_SIDENAV_WIDTH = 200;

export const LIST_CARD_WIDTH = 300;
export const ASIDE_WIDTH = 300;

export const FILETYPE_PICTURE = 'PICTURE';
export const FILETYPE_VIDEO = 'VIDEO';
export const FILETYPE_STREAMING = 'STREAMING';

export const FEEDBACK = {
  created: (prefix: string) => `${prefix} se creo con éxito.`,
  edited: (prefix: string, name: string = '') => `${prefix} "${name}" fue actualizado correctamente.`,
  deleted: (prefix: string, name: string = '') => `Se eliminó ${prefix.toLowerCase()} "${name}" correctamente.`,
  failedCreation: (prefix: string) => `Ocurrió un error al crear ${prefix.toLowerCase()}, inténtalo nuevamente.`,
  failedEdition: (prefix: string, name: string = '') =>
    `Ocurrió un error al editar ${prefix.toLowerCase()} "${name}", inténtalo nuevamente.`,
  failedDeletion: (prefix: string, name: string = '') =>
    `Ocurrió un error al eliminar ${prefix.toLowerCase()} "${name}", inténtalo nuevamente.`,
};

export const FEEDBACK_PREFIXES = {};
